import React from "react";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import { Chip } from "@mui/material";
import type { SxProps, Theme } from "@mui/material";

const issueLabels = {
  address: "Address issue",
  contacts: "Contacts issue",
} as const;

// A problem on the account, flagged the same way wherever it is shown. The error colouring separates
// something wanting attention from a plain fact about the account, such as its being a reseller.
export function AccountIssueChip({ issue, sx }: { issue: keyof typeof issueLabels; sx?: SxProps<Theme> }) {
  return <Chip label={issueLabels[issue]} color="error" size="small" icon={<ReportProblemIcon />} sx={sx} />;
}
